export default (imageElement, timeout = 5000) => (
  new Promise((resolve) => {
    const fauxImage = document.createElement('img');

    fauxImage.src = imageElement.getAttribute('data-src');

    if (imageElement.getAttribute('data-srcset')) {
      fauxImage.srcset = imageElement.getAttribute('data-srcset');
    }

    if (imageElement.getAttribute('sizes')) {
      fauxImage.sizes = imageElement.getAttribute('sizes');
    }

    // Position out of view
    fauxImage.style.position = 'absolute';
    fauxImage.style.left = '-10000px';
    fauxImage.style.opacity = '0';

    const timeoutHandle = setTimeout(() => {
      resolve();
    }, timeout);

    const completeCallback = () => {
      document.body.removeChild(fauxImage);
      clearTimeout(timeoutHandle);
      resolve();
    };

    fauxImage.onload = completeCallback;
    fauxImage.onerror = completeCallback;

    document.body.appendChild(fauxImage);
  })
);
